import { render, staticRenderFns } from "./BodyPc.vue?vue&type=template&id=3ea6ca5a&scoped=true"
import script from "./BodyPc.vue?vue&type=script&lang=js"
export * from "./BodyPc.vue?vue&type=script&lang=js"
import style0 from "./BodyPc.vue?vue&type=style&index=0&id=3ea6ca5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea6ca5a",
  null
  
)

export default component.exports